import { batchExportFile, batchExportTxtFile } from '../../../services/urlConfig';

export function exportFile(columnKey) {
  return `${batchExportFile.url}?columnKey=${columnKey}`;
}
export function exportTxtFile(columnKey) {
  return `${batchExportTxtFile.url}?columnKey=${columnKey}`;
}
